import { render, staticRenderFns } from "./roundModelSingle.vue?vue&type=template&id=3170d2bc&scoped=true&"
import script from "./roundModelSingle.vue?vue&type=script&lang=js&"
export * from "./roundModelSingle.vue?vue&type=script&lang=js&"
import style0 from "./roundModelSingle.vue?vue&type=style&index=0&id=3170d2bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3170d2bc",
  null
  
)

export default component.exports